export default __webpack_public_path__ + "static/de-c0b12513d7d0c49fb676787fd7903d7c.svg";